export default "__VITE_ASSET__0f07eaca__"